import CompLayout from "@/pcomponents/comp/layout/layout";

function BookOrderMain(){
  return (
    <CompLayout >
      
    </CompLayout>
  );
}

export default BookOrderMain;